var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgDHeatingSource = function SvgDHeatingSource(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Leitungen/L\\xFCftung"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 420,
    width: 99.99,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "683.99 424.99 584 424.99 584 426.99 683.99 427.02 683.99 424.99",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "684 423 584 422.97 584 422 684 422 684 423",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584.01,
    y: 428.99,
    width: 99.99,
    height: 1,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "644 420 644 66.5 632 66.5 632 420 637 424.99 639 424.99 644 420",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639 427 639 66.5 637.03 66.5 637 427 639 427",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "641 423 641.03 66.5 642 66.5 642 422.97 641 423",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 634,
    y: 66.5,
    width: 1,
    height: 356.5,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "322 223 296 223 296 235 334 235 322 223",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329 228 296 228 296 229.97 329 230 329 228",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325 226 296 225.97 296 225 325 225 325 226",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "332 232 296 232 296 233 331.97 233 332 232",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "632 101 186 101 186 113 632 113 637.02 108 637.02 106 632 101",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639 106 186 106 186 107.97 639 108 639 106",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635 104 186 103.97 186 103 634.97 103 635 104",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186,
    y: 110,
    width: 449,
    height: 1,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "334 235 334 113 329 108 327 108 322 113 322 223 334 235",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329 230 329 106 327.03 106 327 230 329 230",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "331 233 331.03 110 332 110 332 232.97 331 233",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 110,
    width: 1,
    height: 116,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "516 223 490 223 490 235 528 235 516 223",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523 228 490 228 490 229.97 523 230 523 228",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "519 226 490 225.97 490 225 519 225 519 226",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "526 232 490 232 490 233 525.97 233 526 232",
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "528 235 528 113 523 108 521 108 516 113 516 223 528 235",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523 230 523 106 521.03 106 521 230 523 230",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525 233 525.03 110 526 110 526 232.97 525 233",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 518,
    y: 110,
    width: 1,
    height: 116,
    fill: "#787878"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "631.99 420 584 420 584 432 644 432 631.99 420",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "639 425 584 425 584 426.97 639 427 639 425",
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "635 423 584 422.97 584 422 635 422 635 423",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 584,
    y: 429,
    width: 58,
    height: 1,
    fill: "#787878"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 536,
    y: 408,
    width: 48,
    height: 72,
    fill: "#df1400"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M563.61,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.29-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.68,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.28-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.76,456.06c-.18,0-.36-.06-.52-.19-.37-.3-.44-.86-.15-1.25,3.08-4.18,4.24-7.43,3.37-9.42-.39-.88-1.1-1.41-1.92-2.03-1.04-.78-2.22-1.66-2.85-3.39-.74-2.05-.42-4.49.95-7.24.22-.44.73-.6,1.15-.38.42.23.58.77.36,1.2-1.14,2.28-1.43,4.23-.87,5.78.44,1.23,1.32,1.88,2.24,2.57.94.7,1.9,1.42,2.48,2.73,1.19,2.71.02,6.39-3.57,11.26-.17.23-.42.35-.67.35Z",
    fill: "#fff"
  }))))));
};
export default SvgDHeatingSource;